import { Button } from '@/components/ui/button';

import { useNavigate } from 'react-router-dom';
import { LoginForm } from './LoginForm';

export default function Login() {
  const navigate = useNavigate();
  return (
    <div className='h-screen bg-background '>
      <div className='container lg:bg-white bg-background  relative h-screen  flex flex-col items-center justify-center md:grid lg:max-w-none lg:grid-cols-2 lg:px-0'>
        {/* login card */}
        <div className='px-8 inverted-circle bg-white lg:h-full rounded-2xl '>
          <div className='mx-auto flex w-full h-full flex-col justify-start pt-20 pb-4   sm:w-[350px] '>
            <img
              className='w-[315px] mx-auto -mt-24 lg:-mt-8'
              src='/assets/icons/Hillal.svg'
              alt='logo'
            />

            <div className=' -mt-8'>
              <LoginForm />
            </div>

            {/* <p className='mb-8 lg:mb-0 mx-auto mt-8 flex gap-1 text-center text-xs text-foreground'>
              Dont have an account?{' '}
              <div
                onClick={() => navigate('/signup')}
                className='underline text-primary underline-offset-4 hover:text-primary'
              >
                Sign up Now
              </div>{' '}
            </p> */}
            <p className='px-8 mx-auto mt-auto flex gap-1 text-center text-xs text-textDark'>
              Terms and conditions | Privacy policy
            </p>
          </div>
        </div>

        {/* 2nd hafl  */}
        <div className='relative  hidden h-full flex-col  p-10 text-white lg:flex dark:border-r bg-background'>
          <div className='absolute inset-0 bg-background bg-opacity-60 flex justify-center items-center'>
            <img
              src='/assets/images/login-bg.svg'
              alt='bg'
              className='  object-cover w-[500px] h-[500px]'
            />
          </div>
        </div>
      </div>
    </div>
  );
}
